import { objToUrlParams } from '@/utils'
import request from '@/utils/request'

// 获取商户钱包
export const getFund = (params: any) => request({
    url: '/manage/merchant/' + params + '/fund',
    method: 'get'
})

// 获取商户资金明细列表
export const getTransaction = (params: any) => request({
    url: '/manage/merchant/' + params.merchant_no + '/transaction',
    method: 'get',
    params
})

// 导出商户资金明细列表
export const exportTransaction = (data: any) => request({
    url: '/manage/merchant/' + data.merchant_no + '/transaction/export' + objToUrlParams(data),
    method: 'post'
})

// 商户调整余额
export const setBanance = (data: any) => request({
    url: '/manage/merchant/' + data.merchant_no + '/change-balance',
    method: 'put',
    data
})

// 获取汇率列表
export const getExchangeRateList = (params: any) => request({
    url: '/manage/merchant/' + params.merchant_no + '/exchangerate',
    method: 'get'
})

// 增加汇率
export const addExchangeRate = (data: any) => request({
    url: '/manage/merchant/' + data.merchant_no + '/exchangerate',
    method: 'post',
    data
})

// 编辑汇率
export const setExchangeRate = (data: any) => request({
    url: '/manage/merchant/' + data.merchant_no + '/exchangerate/' + data.id,
    method: 'patch',
    data
})

// 删除汇率
export const delExchangeRate = (data: any) => request({
    url: '/manage/merchant/' + data.merchant_no + '/exchangerate/' + data.id,
    method: 'delete'
})

// 编辑附件
export const editAttach = (data: any) => request({
    url: '/manage/transaction/' + data.id + '/edit',
    method: 'patch',
    data
})
